/* eslint-disable no-use-before-define */
import {
    isNaN,
    isInteger,
    includes,
    forEach,
    get,
} from 'lodash';

import {
    RANGE_IPC_CPC_FIELDS,
    RANGE_LOC_FIELDS,
//   RANGE_FTERM_FIELDS,
//   RANGE_UPC_FIELDS
} from '../config/index';

const rangeIpcCpcReg = /^[A-Za-z0-9]+\/[0-9]+$/; // 字符数字组合/数字 例如A61N2/06
// eslint-disable-next-line no-useless-escape
const rangeLocReg = /^[0-9]+\-[0-9]+$/; // 数字-数字 例如 10-01
// const rangeFtermReg = /^[A-Za-z0-9]+\/[A-Za-z0-9]+$/; // 字符数字组合/字符数字组合 例如2B022/BA01
// const rangeUpcReg = /^[0-9]+\-[0-9.]+$/; // 格式为 数字/数字（可能含有点号.） 例如 105/1.4
const alphabetNumberReg = /^(?=[a-zA-Z0-9]*[a-zA-Z][a-zA-Z0-9]*)([a-zA-Z0-9]*[0-9][a-zA-Z0-9]*)$/; // 同时包含字符数字组合
/**
 * 判断值是否为时间类型
 * @param {*} str
 */
function isDateValue(str) {
    return (
        /^[1-2]\d{3}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/.test(str)
        || /^[1-2]\d{3}$/.test(str)
        || /^[1-2]\d{3}(0[1-9]|1[0-2])$/.test(str)
    );
}
/**
 * 判断值是否为数值类型
 * @param {*} str
 */
function isIntegerValue(str) {
    const strNum = Number(str);
    return !isNaN(strNum) && isInteger(strNum);
}

/**
 * 比较时间类型范围值是否前面小于等于后面的值
 * @param {*} rangeStart 开始值
 * @param {*} rangeEnd 结束值
 */
function isCorrectRange(rangeStart, rangeEnd) {
    let isCorrect = false;
    if (_formateDate(rangeStart) <= _formateDate(rangeEnd)) {
        isCorrect = true;
    }
    return isCorrect;
}

/**
 *
 * @param {str}
 * @param {field}
 */
function isCorrectClassification(str, field) {
    let isCorrect = false;
    if (includes(RANGE_IPC_CPC_FIELDS, field)) {
        if (rangeIpcCpcReg.test(str)) {
            const startStr = str.split('/')[0];
            if (alphabetNumberReg.test(startStr)) {
                isCorrect = true;
            }
        }
    }
    if (includes(RANGE_LOC_FIELDS, field)) {
        if (rangeLocReg.test(str)) {
            isCorrect = true;
        }
    }
    return isCorrect;
}

function isStartStrSame(rangeStart, rangeEnd) {
    // eslint-disable-next-line no-useless-escape
    const reg = /[\/\-]/;
    const rsStr = rangeStart.split(reg)[0];
    const reStr = rangeEnd.split(reg)[0];
    return rsStr === reStr;
}

/**
 * 将时间格式统一格式为8位时间格式
 * @param {*} time
 */
// eslint-disable-next-line no-underscore-dangle
function _formateDate(_time) {
    let time = _time;
    switch (time.length) {
    case 4:
        time = parseInt(`${time}0101`, 10);
        break;
    case 6:
        time = parseInt(`${time}01`, 10);
        break;
    default:
        time = parseInt(time, 10);
        break;
    }
    return time;
}

/**
 * 校验是否存在字段表达式
 * */
function checkHasFieldExp(data) {
    const typeList = [];
    const treeDataToList = (treeData) => {
        const expressionType = get(treeData, 'expressionType');
        if (expressionType) {
            typeList.push(expressionType);
        }
        if (treeData.children) {
            forEach(treeData.children, (item) => {
                treeDataToList(item);
            });
        }
    };
    forEach(data, (item) => {
        if (item) {
            treeDataToList(item);
        }
    });
    const hasFieldExp = includes(typeList, 'fieldExp');
    return hasFieldExp;
}

export {
    isDateValue,
    isIntegerValue,
    isCorrectRange,
    isCorrectClassification,
    isStartStrSame,
    checkHasFieldExp,
};
